import React from 'react'
import { QuestionCardDefaultOptions } from '.'
import { useAppDispatch, useAppSelector } from '../../../App.store'
import {
  QuestionSettingCode,
  SettingValue
} from '../../../data/model/questionnaire'
import useSetQuestionnaireSetting from '../../../hooks/questionnaire/useSetQuestionnaireSetting'
import {
  WithEntry,
  getQuestionEnabledSettings
} from '../../../utils/questionnaireUtils'
import {
  selectSettingsByQuestionId,
  setQuestionSetting
} from '../Questionnaire.slice'
import { getEntryId, getSettingValuesFromEntry } from '../Questionnaire.utils'

type DefaultOption =
  | QuestionSettingCode.NoneOfThese
  | QuestionSettingCode.PreferNotToSay
  | QuestionSettingCode.DontKnow
  | QuestionSettingCode.TextHighlighterComments

export interface Option {
  code: DefaultOption
  label: string
}

interface Props extends WithEntry {
  options?: Option[]
}

const DefaultOptions: React.FC<Props> = (props: Props) => {
  const { entry, options } = props
  const entryId = getEntryId(entry)
  const { handleSettingChange } = useSetQuestionnaireSetting(entry)

  const dispatch = useAppDispatch()
  const settingValues =
    // @todo Legacy eslint violation – fix this when editing
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    useAppSelector((state) => selectSettingsByQuestionId(state, entryId)) ||
    getSettingValuesFromEntry(entry)

  const changeSettingValue = async (
    code: QuestionSettingCode,
    value: SettingValue
  ) => {
    dispatch(
      setQuestionSetting({
        questionLk: entryId,
        code,
        value
      })
    )
    await handleSettingChange(
      [{ settingCode: code, settingValue: value }],
      'no-cache'
    )
  }

  const enabledSettings = getQuestionEnabledSettings(settingValues)

  return (
    <QuestionCardDefaultOptions
      entry={entry}
      options={options?.map((option) => ({
        ...option,
        checked: enabledSettings.has(option.code),
        onChange: (
          settingValue: SettingValue.Enabled | SettingValue.Disabled
        ) => {
          changeSettingValue(option.code, settingValue)
        }
      }))}
    />
  )
}

export default DefaultOptions
